import { useEffect, useState } from "react";
import Common from "../../helper/common";
import { Button } from "../../components/ui/button";
import { Icon } from "@iconify/react";
import AdvanceTable from "../../components/advanceTable";
import AddBinNumber from "./bins/addbinnumber";
import { SearchTypeEnum } from "../../constants/appConstant";

const BinNumbers = () => {

  const [data, setData] = useState({});
  const [open, setOpen] = useState(false);
  const [refId, setRefId] = useState(null);

  useEffect(() => {
    if (!open && refId) {
      setRefId();
    }
  }, [open, refId]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async (
    pageNumber,
    searchTerm = "",
    recordsToDisplay = null
  ) => {

    const response = await Common.ApiService.getInstance().request(
      "GetBinNumberList",
      {
        pageNumber: pageNumber,
        q: searchTerm,
        isactive: true,
        recordsToDisplay,
      },
      "Post"
    );

    if (response?.data) {
      debugger;
      let obj = {
        ...response.data[0],
        data: response.data[0].data.map((item) => ({
          ...item,
          bank: item.bank ?? "-",
          scheme:item.scheme ?? "-",
          bin:item.bin ?? "-"
        })),
      };
      setData(obj);
    }
  };

  const columns = [
    { title: "Bin Number", type: "number", isVisible: true, key: "bin" },
    { title: "Bank", type: "text", isVisible: true, key: "bank" },
    { title: "Scheme", type: "text", isVisible: true, key: "scheme" },
  ];

  const actions = [
    {
      type: "edit",
      onClick: (val) => _onEdit(val.id),
    },
    {
      type: "delete",
      onClick: (val) => _handleDelete(val.id),
    },
  ];

  const _onEdit = async (id) => {
    setOpen(true);
    setRefId(id);
  };

  const _handleDelete = async (id) => {
    const isConfirmed = await Common.SweetAlert.confirmation(
      "Are you sure want to delete this Bin Number??",
      "Delete Bin Number"
    );

    if (isConfirmed) {
      let resp = await Common.ApiService.getInstance().request(
        `DeleteBinNumber?id=${id}`,
        {},
        "Delete"
      );
      Common.SweetAlert.alert(resp.message, "success");
      setTimeout(() => {
        getData(1);
      }, 500);
    }
  };

  const _addUpdateTrigger = () => {
    <Button size="icon" variant="outline" color="secondary" className="h-7 w-7">
      <Icon icon="heroicons:pencil" className="h-4 w-4" />
    </Button>;
  };

  return (
    <>
      {data?.data && (
        <AdvanceTable
          title={"Bin Numbers"}
          columns={columns.filter((item) => item.isVisible)}
          data={data}
          getData={getData}
          addButton={() => (
            <AddBinNumber
              id={refId}
              onClose={() => getData()}
              open={open}
              setOpen={setOpen}
            />
          )}
          showPagination
          showAddButton
          actionButtons={actions}
          updateTrigger={_addUpdateTrigger}
          search={SearchTypeEnum.Local_Search}
          searchInputClassName="custom-search-mobile"
        />
      )}
    </>
  );
};

export default BinNumbers;
